import React from 'react';
import { Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';

import { INTEGRATION_PREVIEW_FORM_NAME, InputMode } from 'Common/FormEnum';
import { InputField } from 'Common/SemanticWrapper';
import { SISFieldEnum } from 'Common/Constants/SISIntegration';

const IntegrationPreviewForm = props => {
  return (
    <Grid>
      <Grid.Column width="6">
        <Field
          maxLength="12"
          label="Student Id"
          name={SISFieldEnum.StudentId}
          component={InputField}
          onChange={props.onChange}
          loading={props.loading}
          disabled={props.loading}
          mode={InputMode.Integer}
        />
      </Grid.Column>
    </Grid>
  );
};

const validate = values => {
  if (!values['studentId']) {
    return { studentId: 'Student ID is required' };
  }
};

export default reduxForm({
  form: INTEGRATION_PREVIEW_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(IntegrationPreviewForm);



// WEBPACK FOOTER //
// ./src/components/SISIntegrations/IntegrationPreviewForm.js